import * as angular from 'angular';
import * as d3 from 'd3';
import * as moment from 'moment';

import { IGroupService, IReferenceStateService } from '../../../services';
import { IWidgetFactory } from '../../../widgets';
import {
    lineChartLeftMargin,
    lineChartRightMargin,
    lineChartTopMargin,
    lineChartBottomMargin,
} from '../../../framework';

export interface IGroupTrendService {
    load(groupGuid: string): angular.IPromise<any>;
    loadStates(groupGuid: string, data?: any, force?: boolean):angular.IPromise<{calculated:any, reference:any, data:any}>;
}

export class GroupTrendService implements IGroupTrendService {

    static serviceId = 'groupTrendService';
    static $inject = ['$q', '$translate', 'groupService', 'referenceStateService', 'widgetFactory'];

    constructor(
        private _$q: angular.IQService,
        private _$translate: angular.translate.ITranslateService,
        private _groupService: IGroupService,
        private _referenceStateService: IReferenceStateService,
        private _widgetFactory: IWidgetFactory
    ) {
    }

    load(groupGuid: string) {
        const trend = this._widgetFactory.createWidget('tagsTrend') as any;
        trend.configuration.isEndDateIncluded = true;
        trend.configuration.hideMissing = false; //group.group.frequency.interval > 0;
        trend.configuration.options.panes = this.resetPane();
        trend.configuration.options.isTitleVisible = false;
        return this.loadGroupConfiguration(groupGuid, trend);
    }

    private loadGroupConfiguration(groupGuid: string, trend) {
        return this._groupService
            .getConfigurationForGroup(groupGuid)
            .then(configuration => {
                trend.configuration.series = configuration.seriesConfigurationCollection
                    .sort((a, b) => d3.ascending(a.sortOrder, b.sortOrder));
                // return this.loadStates(groupGuid);
                return trend;
            });
    }

    loadStates(groupGuid: string, data?: any, force: boolean = false) {
        // if (data) {
        //     trend.configuration.options.display.xMin = data.beginDateTime;
        //     trend.configuration.options.display.xMax = data.endDateTime;
        // }
        const promises = [
            this.loadReferenceStates(groupGuid, force),
            this._groupService.getActualStates(groupGuid, force)
        ];
        return this._$q.all(promises)
            .then(responses => {
                const areas = responses[1].map(rs => {
                    return {
                        name: rs.name,
                        color: rs.color,
                        beginDate: moment(rs.beginDateTime).toDate(),
                        endDate: moment(rs.endDateTime).toDate()
                    };
                });
                return {
                    reference: responses[0],
                    calculated: areas,
                    data
                };
                // return trend;
            });
    }

    private loadReferenceStates(groupGuid: string, trend: any, force: boolean = false): angular.IPromise<any> {
        return this._groupService
            .getReferenceStates(groupGuid, force)
            .then(responses => {
                const areas = responses
                    .map(d => this._referenceStateService.getReferenceStateAreaConfiguration(d));
                return areas;
            });
    }

    private resetPane() {
        return [
            {
                height: 81,
                isXaxisVisible: false,
                isLegendVisible: true,
                areas: [],
                // to ensure range series are vertical aligned
                isTitleVisible: false,
                isTitleLeftAligned: true,
                margins: {
                    marginLeft: lineChartLeftMargin,
                    marginRight: lineChartRightMargin,
                    marginTop: lineChartTopMargin,
                    marginBottom: 10
                }
            },
            {
                height: 8,
                minHeight: 45,
                isXaxisVisible: false,
                isYaxisVisible: false,
                isLegendVisible: false,
                yMin: 0,
                yMax: 1,
                // areaClickCallback: this.stateClickCallback(),
                // brushCallback: (extent) => {
                //     this.trend.configuration.options.panes[1].editedArea.beginDate = extent[0];
                //     this.trend.configuration.options.panes[1].editedArea.endDate = extent[1];
                //     $scope.$apply();
                // },
                // brushEndCallback: (extent: [Date, Date]) => {
                //     this.onBrushend(extent);
                // },
                title: this._$translate.instant('Reference states'),
                isTitleVisible: true,
                isTitleLeftAligned: true,
                margins: {
                    marginLeft: lineChartLeftMargin,
                    marginRight: lineChartRightMargin,
                    marginTop: lineChartTopMargin,
                    marginBottom: 10
                }
            },
            {
                height: 11,
                minHeight: 65,
                isXaxisVisible: true,
                isYaxisVisible: false,
                yMin: 0,
                yMax: 1,
                isLegendVisible: false,
                title: this._$translate.instant('Calculated states'),
                isTitleVisible: true,
                isTitleLeftAligned: true,
                margins: {
                    marginLeft: lineChartLeftMargin,
                    marginRight: lineChartRightMargin,
                    marginTop: lineChartTopMargin,
                    marginBottom: lineChartBottomMargin
                }
            }
        ];
    }
}